import { Stack, DialogContent } from "@mui/material";

export default function NewDialogContent({ children, isPopup = false }) {
  return (
    <DialogContent sx={{ p: 0, height: "100%" }}>
      <Stack
        height={{
          sm: isPopup ? "75vh" : "calc(100vh - 64px - 64px)",
          xs: isPopup ? "75vh" : "calc(100vh - 64px - 64px - 56px)",
        }}
      >
        {children}
      </Stack>
    </DialogContent>
  );
}

// Footer -> 64px
// Header -> 64px
// NewDialogActions -> 56px
